<template>
  <div class="page-container">
    <div class="container">
      <div class="row mb-4 mt-3">
        <div class="col-12 text-center">
          <img src="/img/vertical-logo-name.svg" class="mt-4" height="400" />
        </div>
      </div>

    </div>
    <div class="container">
      <button class="btn-block btn-dark-blue" @click.prevent="registrar">INSCRIÇÃO</button>
      <button class="btn-block btn-light-blue" @click.prevent="entrar">ENTRAR</button>
    </div>
    <footer class="footer">
      <div class="d-flex space-between p-3">
        <img src="/img/instituto-azul-marinho.png" height="35" />
        <img src="/img/governo-federal.png" height="35" />
      </div>
    </footer>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {

    };
  },
  created() {

  },

  methods: {
    async registrar() {
      this.$router.push("/registro");
    },
    async entrar() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>


.btn-dark-blue {
  font-weight: bold;
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #0D4275;
  border-radius: 5px;
  background: #0D4275;
  color: #fff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.btn-light-blue {
  font-weight: bold;
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #3BAED9;
  border-radius: 5px;
  background: #3BAED9;
  color: #fff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .desktop {
    display: none;
    height: 100vh;
  }
}

@media (min-width: 768px) {
  .mobile {
    display: none;
  }
}
</style>
